<script>
import moment from 'moment'

const props = {
  items: {
    type: Object,
  },
  width: {
    type: Number,
    default: 1100,
  },
  height: {
    type: Number,
    default: 300,
  },
}

export default {
  props: props,
  data () {
    return {
      awaiting: 'emailReads',
    }
  },
  methods: {
    showNa (props, timeframe = null) {
      const locTimeframe = timeframe || this.timeframe

      return (
        props !== null &&
        locTimeframe.includes('days') &&
        moment().utc().isBefore(moment.utc('7:00am', 'h:mma')) &&
        (props.includes(this.awaiting) || props.filter((p) => p !== null && p.includes(this.awaiting)).length > 0)
      )
    },
  },
}
</script>
